<template>
  <v-card
      height="330"
      class="rounded-lg white"
  >
    <v-card-title class=" mr-3 mt-3 secondary--text">
      <v-img class="ml-3" src="/img/icons/bell-circle.svg" max-width="25" max-height="25"></v-img>
       آخرین اعلان های  <span class="info--text mr-2">ارسالی</span>
      <v-spacer></v-spacer>
      <v-tooltip right >
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" fab icon class="mr-3" href="notificationsList">
            <v-img class="" src="/img/icons/info_circle.svg" max-width="23"></v-img>
          </v-btn>
        </template>
        مشاهده کامل
      </v-tooltip>
    </v-card-title>
    <v-simple-table class="mr-2 ml-2 rounded-b-lg">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-center">
            عنوان
          </th>
          <th class="text-center">
            توضیحات
          </th>
          <th class="text-center">
            تاریخ و ساعت
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="notification in notifications">
          <td class="text-center">{{notification.title}}</td>
          <td class="text-center">{{notification.explanation}}</td>
          <td class="text-center">{{notification.created_at}}</td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
export default {
  name: "PostedNotifications",
  components: {
  },
  props: {
    id: {},
  },
  data() {
    return {
      notifications : null
    };
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData(){
      this.request({
        url: this.endpoint('users/sendNotification/?limit=5&offset=0&search='),
        method: "get",
        success: data => {
          this.notifications = data.results.slice(0,4)
        },
      })
    }
  },

}
</script>

<style scoped lang="scss"></style>

